import { useSelector } from 'react-redux';
import { getClearance, getClearanceAmount } from '../../selector';
import { IStore } from 'store/interface';
import { IClearanceRecord } from '../../interfaces';

export const useClearance = () => ({
  items: useSelector<IStore, IClearanceRecord['items']>(getClearance),
  amount: useSelector<IStore, IClearanceRecord['amount']>(getClearanceAmount),
});
